import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  coverImage: string;
  duration: string;
  views: string;
  author: string;
  authorAvatar: string;
  category: string;
}

export default function VideoCard({ id, title, coverImage, duration, views, author, authorAvatar }: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded-md font-medium">
          {duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
            <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors duration-200">
          {title}
        </h3>
        <div className="flex items-center gap-2">
          <img
            src={authorAvatar}
            alt={author}
            className="w-6 h-6 rounded-full object-cover flex-shrink-0"
          />
          <span className="text-xs text-foreground-500 truncate">{author}</span>
          <span className="text-xs text-foreground-400 ml-auto whitespace-nowrap">{views}次观看</span>
        </div>
      </div>
    </Link>
  );
}